import React from 'react';

export const ContentBox = ({ id, children, noBorder, className }) => (
  <div
    id={id}
    data-e2e="search-results-box"
    className={`ct-content-box ${noBorder ? ' ct-content-box--noborder' : ''}${className ? className : ''}`}
    tabIndex={id ? '-1' : undefined}
  >
    {children}
  </div>
);
